module.exports = __webpack_public_path__ + "media/audio117.4ebd7afa.mp3";